import { Directive } from '@angular/core';

@Directive({
  selector: '[appJumptoError]',
  exportAs: 'appJumptoError',
})
export class JumptoErrorDirective {
  public check(): void {
    const erroredElements = document.querySelectorAll('.has-error');

    if (erroredElements.length) {
      const el = erroredElements[0];
      const offset = pageYOffset + el.getBoundingClientRect().top;
      window.scroll(0, offset - 100);
    }
  }
}

